var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { styled } from 'styled-components';
import { EditContainer, Cell, MainTextField, ExtraTextFieldContainer, ExtraTextField, ConfirmationButtonsContainer, } from '../Common';
import { AddButton, CancelButton } from '../../Buttons';
var AddContainer = styled(EditContainer).withConfig({ displayName: "AddContainer", componentId: "sc-182decc" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 16px;\n"], ["\n  margin-top: 16px;\n"])));
var AddStudentRow = function (_a) {
    var defaultPassword = _a.password, index = _a.index, onAdd = _a.onAdd, onCancel = _a.onCancel;
    var _b = useState(''), name = _b[0], setName = _b[1];
    var _c = useState(defaultPassword), password = _c[0], setPassword = _c[1];
    var rowRef = useRef(null);
    var handleOnNameChange = function (event) {
        setName(event.currentTarget.value);
    };
    var handleOnPasswordChange = function (event) {
        setPassword(event.currentTarget.value);
    };
    var handleOnSave = function () {
        return onAdd({
            name: name,
            password: password,
        });
    };
    var hasEmptyFields = name.length === 0 || password.length === 0;
    useEffect(function () {
        var _a;
        (_a = rowRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
    }, []);
    return (_jsxs(AddContainer, __assign({ ref: rowRef }, { children: [_jsx(Cell, { children: index }, void 0), _jsx(Cell, { children: _jsx(MainTextField, { value: name, onChange: handleOnNameChange, placeholder: 'Student Name' }, void 0) }, void 0), _jsxs(Cell, { children: [_jsx(ExtraTextFieldContainer, { children: _jsx(ExtraTextField, { value: password, onChange: handleOnPasswordChange, placeholder: 'Password' }, void 0) }, void 0), _jsxs(ConfirmationButtonsContainer, { children: [_jsx(AddButton, { title: 'Add student', onClick: handleOnSave, disabled: hasEmptyFields }, void 0), _jsx(CancelButton, { title: 'Cancel', onClick: onCancel }, void 0)] }, void 0)] }, void 0)] }), void 0));
};
export { AddStudentRow };
var templateObject_1;
